import React from "react";
import { Modal } from "seed/helpers";
import l from "components/util/l";
import ManageEnvironment from "components/presentation/environments/ManageEnvironment";
import MergeEnvironment from "components/presentation/environments/MergeEnvironment";
import { environmentLabel } from "components/presentation/environments/Environments.lib";
import "styles/css/presentation/Environments.css";

const EnvironmentsView = ({
  current,
  environments,
  flow,
  isManageOpen,
  isMergeOpen,
  isProduction,
  onChanged,
  onClickEnvironment,
  onClickManage,
  onClickMerge,
  onCloseManage,
  onCloseMerge,
  onDeleted
}) =>
  <span className="d-none d-md-flex align-items-center mr-2">


    <div className="dropdown">
      <button
        type="button"
        className="btn btn-sm btn-dark option-button font-weight-bold dropdown-toggle"
        style={{paddingRight: "0.75rem", paddingLeft: "0.75rem", backgroundColor: "#1020304a", borderColor: "#a0b0c020"}}
        data-toggle="dropdown"
        aria-haspopup="true"
        aria-expanded="false"
      >
        <i className="fas fa-code-branch" style={{marginLeft: "0.15rem", marginRight: "0.5rem"}}></i>
        {current ? environmentLabel(current) : "—"}
        {isProduction && <span className="environment-live-dot ml-2" title={l("Producción%EN015")}></span>}
      </button>

      <div className="dropdown-menu">
        <span className="dropdown-header">{l("Entorno%EN021")}</span>
        {environments.map((item) => (
          <button
            key={item.id}
            type="button"
            className={`dropdown-item d-flex align-items-center justify-content-between ${item.id == current?.id ? "active" : ""}`}
            onClick={() => onClickEnvironment(item.id)}
          >
            <span>
              {environmentLabel(item)}
              <small>{item.is_root ? ` (${l("Principal%EN027")})` : ""}</small>
            </span>
          </button>
        ))}

        <div className="dropdown-divider"></div>

        <button type="button" className="dropdown-item" onClick={onClickManage}>
          <i className="dropdown-item-icon fas fa-cog mr-2"></i>{l("Configuración%GA120")}
        </button>
      </div>
    </div>

    {
      isManageOpen &&
      <Modal width="450" onClose={onCloseManage}>
        <ManageEnvironment
          flow={flow}
          environments={environments}
          onChanged={onChanged}
          onClickMerge={onClickMerge}
          onDeleted={onDeleted}
        />
      </Modal>
    }

    {
      isMergeOpen &&
      <Modal width="520" onClose={onCloseMerge}>
        <MergeEnvironment flow={flow} environments={environments} />
      </Modal>
    }

  </span>

export default EnvironmentsView;
